// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import ConvoyMenu from './ConvoyMenu'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectAu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {





    }



    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='9' />
                <div className='dv_project_body'>
                    <ConvoyMenu activeMenu={1} />
                    <div className='dv_project_body_right' id="mydiv">
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000001.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000002.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/convoy/55_000055.jpg")} />
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectAu);